import { render, staticRenderFns } from "./HoldForm.vue?vue&type=template&id=1c322f1e"
import script from "./HoldForm.vue?vue&type=script&lang=js"
export * from "./HoldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports